const ExecutiveSplitSection = ({
  title,
  accentBar = 'bg-slate-400',
  illustration,
  illustrationPosition = 'right',
  children,
  theme,
  className = '',
}) => {
  const isDark = theme === 'dark';
  const prose = (
    <div className={`space-y-6 text-lg lg:text-xl leading-relaxed ${isDark ? 'text-slate-300' : 'text-slate-700'}`}>
      {children}
    </div>
  );
  const visual = illustration ? (
    <div className="w-full">{illustration}</div>
  ) : null;

  return (
    <div className={className}>
      {title && (
        <div className="mb-10">
          <div className={`h-1 w-16 ${accentBar} mb-6`} />
          <h2 className={`text-3xl lg:text-4xl font-bold ${isDark ? 'text-white' : 'text-slate-900'}`}>{title}</h2>
        </div>
      )}
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {illustrationPosition === 'left' ? (
          <>
            {visual}
            {prose}
          </>
        ) : (
          <>
            {prose}
            {visual}
          </>
        )}
      </div>
    </div>
  );
};

export default ExecutiveSplitSection;
